import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output,
  signal,
  Signal, SimpleChanges,
  WritableSignal
} from '@angular/core';
import {CommonModule} from '@angular/common';

import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSelectChange, MatSelectModule} from '@angular/material/select';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {Router} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule } from '@angular/forms';

import {ProceduresService} from '../../../services/procedures/procedures.service';
import {CategoryService} from '../../../services/categories/categories.service';
import {ModesService} from '../../../services/modes/modes.service';
import {TypesService} from '../../../services/types/types.service';
import {ProcedureBody} from '../../../models/procedures/ProcedureBody';
import {EtatsService} from '../../../services/etats/etats.service';

import {ConnectedUser, InitialAuthService} from '../../../shared/auth/initial-auth.service';
import {FileUploadDndComponent} from '../../file-upload-dnd/file-upload-dnd.component';
import {MatSnackBar, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {dateRangeValidator} from "../../../shared/validators/date-validator";
import {MatChipsModule} from "@angular/material/chips";
import {AnnexesService} from "../../../services/annexes/annexes.service";
import {
  debounceTime, filter,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  startWith,
  Subscription,
  switchMap,
  take
} from "rxjs";
import {PerimetresService} from "../../../services/perimetres/perimetres.service";
import {MatAutocomplete, MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {NgxPermissionsService} from "ngx-permissions";
import {MatDialog} from '@angular/material/dialog';
import {DeleteProcedureDialogComponent} from '../delete-procedure-dialog/delete-procedure-dialog.component';
import {DocumentViewDialogComponent} from './document-view-dialog/document-view-dialog.component';
import {Annexe} from '../../../models/annexes/AnnexeBody';
import {BreadcrumbComponent} from '../../breadcrumb/breadcrumb.component';
import {GroupesService} from '../../../services/groupes/groupes.service';
import {Groupe} from '../../../models/groupes/Groupe';
import {JointjsModalComponent} from "../jointjs-modal/jointjs-modal.component";
import {ProfilService} from "../../../services/profil/profil.service";
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {Sub} from "select2";
import {HttpErrorResponse} from "@angular/common/http";
import {JointjsPageComponent} from "../jointjs-page/jointjs-page.component";
import {JointjsReadonlyModalComponent} from "../jointjs-readonly-modal/jointjs-readonly-modal.component";
import { EmargementsUsersService } from '../../../services/emargements-users/emargements-users.service';


enum EtatEnum {
  EN_APPLICATION = 'En application',
  EN_ATTENTE = 'En attente d\'activation',
  ARCHIVE = 'Archivé'
}

enum TypeProcedureEnum {
  PROCEDURE_INITIALE = 'Procédure d\'Exploitation',
  POE = 'POE',
  IOE = 'IOE'
}

const DEFAULT_PROCEDURE_VERSION: number = 1;

@Component({
  selector: 'app-create-procedure',
  templateUrl: './create-procedure.component.html',
  styleUrl: './create-procedure.component.scss',
  standalone: true,
  providers: [],
  imports: [
    CommonModule, MatTableModule, MatIconModule, MatSortModule, MatPaginatorModule, MatInputModule,
    MatCardModule, MatDividerModule, MatSelectModule, MatCheckboxModule, MatButtonModule,
    MatDatepickerModule, FileUploadDndComponent, MatFormFieldModule, MatRadioModule, MatButtonToggleModule,
    FormsModule, ReactiveFormsModule, MatChipsModule, MatAutocomplete, MatAutocompleteTrigger, BreadcrumbComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CreateProcedureComponent implements OnInit, OnChanges, OnDestroy {
  protected readonly EtatEnum = EtatEnum;
  private readonly _procdureInitialeLibelle = "Procédure d'Exploitation";
  filteredProceduresMnemonique: Observable<any[]> | undefined;
  filteredProceduresMnemoniqueRef: Observable<any[]> | undefined;
  filteredProceduresTitre: Observable<any[]> | undefined;

  files: any[] = [];
  connectedUser: ConnectedUser | undefined;

  procedureForm: FormGroup;
  categories: any;
  modes: any;
  types: any;
  etats: any;
  perimetres: any;
  logigramme: any;
  currentEtat: string | undefined;
  isAdmin: boolean = false;
  isIOE: boolean = false;
  isPOE: boolean = false;
  procedureReference: any;
  subscriptions: Subscription[] = [];
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  isEnApplication = false;
  groupes: Groupe[] = [];
  selectedGroups: Groupe[] = [];
  filteredGroupes!: Observable<Groupe[]>;
  listeUtilisateursIds: number[] = [];

  canUserModify: WritableSignal<boolean>;

  @Input() idEditMode!: boolean;
  @Input() procedure!: any;
  @Input() readOnly!: boolean;
  @Input() openLogigramme!: boolean;

  @Input() emargementForm!: FormGroup;
  @Input() emargementUser: any;
  @Input() emargementData!: {
    showEmargement: boolean;
    emargementUser: any;
  };

  @Output() emargementValidated = new EventEmitter<void>();

  public emargementDone: boolean;

  constructor(
    private fb: FormBuilder,
    private authService: InitialAuthService,
    private router: Router,
    private proceduresService: ProceduresService,
    private categoryService: CategoryService,
    private modeService: ModesService,
    private typeService: TypesService,
    private etatService: EtatsService,
    private annexeService: AnnexesService,
    private perimetreService: PerimetresService,
    private permissionsService: NgxPermissionsService,
    private groupesService: GroupesService,
    private profilService: ProfilService,
    private emargementsUsersService: EmargementsUsersService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {
    this.procedureForm = this.fb.group({
      type: ['', Validators.required],
      isSecurite: ['non', Validators.required],
      mnemoniqueRef: [''],
      mnemonique: ['', Validators.required],
      titre: ['', Validators.required],
      reference: ['', Validators.required],
      version: [ { value: DEFAULT_PROCEDURE_VERSION, disabled: true }, Validators.required],
      tags: this.fb.array([]),
      dateDebutValidite: [''],
      dateFinValidite: [''],
      category: ['', Validators.required],
      mode: ['', Validators.required],
      etat: [''],
      groupeDiffusion: ['', Validators.required],
      perimetre: ['', Validators.required],
      annexes: [''],
      contexte: [''],
      commentaire: [''],
      logigramme: [null],
    }, {
      validators: [dateRangeValidator('dateDebutValidite', 'dateFinValidite')
      ]
    });
    this.canUserModify = signal(false);
  }

  async ngOnInit(): Promise<void> {
    const currentProfil = await firstValueFrom(this.profilService.currentProfile$);
    console.log('currentProfil', currentProfil);
    this.isAdmin = currentProfil === 'Administrateur OPUS';
    await this.loadCategories();
    await this.loadModes();
    await this.loadTypes();
    await this.loadEtat();
    await this.loadPerimetres();
    await this.loadUser();
    this.loadGroupes();

    if (this.procedure) {
      await this.loadSelectedGroups();
      const etat = this.etats.find((etat: any) => etat.id === this.procedure.etat?.id);
      this.currentEtat = etat.libelle;
      if(this.procedure.etat.libelle === 'En application'){
        this.isEnApplication = true;
      }

      let mnemoRef = "";
      if (this.procedure.mnemoniqueRef) {
        const res = await firstValueFrom(this.proceduresService.getProcedureById(this.procedure.mnemoniqueRef));
        mnemoRef = res.data.mnemonique;
      }

      this.logigramme = this.procedure.logigramme;

      this.procedureForm.patchValue({
        type: this.procedure.type.id,
        isSecurite: this.procedure.isSecurite,
        mnemoniqueRef: mnemoRef,
        mnemonique: this.procedure.mnemonique,
        titre: this.procedure.titre,
        reference: this.procedure.reference,
        version: this.procedure.version,
        category: this.procedure.category.id,
        mode: this.procedure.mode.id,
        etat: this.procedure.etat.id,
        dateDebutValidite: this.formatDate(this.procedure.dateDebutValidite),
        dateFinValidite: this.formatDate(this.procedure.dateFinValidite),
        annexes: this.procedure.annexes,
        contexte: this.procedure.contexte,
        commentaire: this.procedure.commentaire,
        perimetre: this.procedure.perimetre.id,
        logigramme: this.procedure.logigramme
      });
      const tagsFormArray = this.procedureForm.get('tags') as FormArray;
      this.procedure.tags.forEach((tag: string) => {
        tagsFormArray.push(this.fb.control(tag));
      });
    }

    this.filteredProceduresMnemonique = this.procedureForm.controls['mnemonique'].valueChanges.pipe(
      startWith(''),
      switchMap(value => this.filterProceduresByMnemonique(value, false))
    );

    this.filteredProceduresMnemoniqueRef = this.procedureForm.controls['mnemoniqueRef'].valueChanges.pipe(
      startWith(''),
      switchMap(value => this.filterProcedures(value, false))
    );

    this.filteredProceduresTitre = this.procedureForm.controls['titre'].valueChanges.pipe(
      startWith(''),
      switchMap(value => this.filterProceduresByTitre(value, false))
    );

    this.filteredGroupes = this.procedureForm.controls['groupeDiffusion'].valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      switchMap(value => this.filterGroupes(value))
    );

    this.incrementProcedureVersionWhenFormulaireChangesOnce();

  }

  // Pour gérer l'ouverture automatique de la pop up de consultation du logiramme, on check que c'est bien demandé (openLogigramme) et que  procédure est bien là
  ngOnChanges(changes: SimpleChanges): void {
    if( this.openLogigramme && changes['procedure'].previousValue == undefined ) {
      this.logigramme = this.procedure.logigramme;
      this.openReadOnlyLogigrammeDialog();
    }
  }

  private incrementProcedureVersionWhenFormulaireChangesOnce() {
    // On check qu'on est bien dans le cas d'une modification
    if (this.procedure) {
      // le take 1 sert à trigger le valueChange une seule fois (au premier changement) pour pouvoir incrementer la version une seule fois
      let procedureFormValueChangesSubscription : Subscription = this.procedureForm.valueChanges.pipe(take(1)).subscribe(() => {
        // On incrémente la version
        this.procedureForm.controls["version"].setValue(
          +this.procedureForm.controls["version"].value + 1
        );

        // On check bien que la valeur de value est bien un nombre, dans le cas contraire, on met la valeur par default.
        if(isNaN(this.procedureForm.controls["version"].value)) {
          this.procedureForm.controls["version"].setValue(
            DEFAULT_PROCEDURE_VERSION
          );
        }

        // On met le boolean qui gere le disable du button enregistrer
        this.canUserModify.set(true);

        // on informe l'utilisateur que la version à bien ètè incrementer
        this.openSnackBar(`Vous êtes maintenant en version ${this.procedureForm.controls["version"].value}`, 'Fermer');
      })
      // On ajoute le subscribe au niveau du tableau des subscribes pour pouvoir unsubscribe dans le ngOnDestroy
      this.subscriptions.push(procedureFormValueChangesSubscription);
    }
  }

  private reInitProcedureVersionWhenFormulaireDidntChangeAfterBffCheck() {
    // On check qu'on est bien dans le cas d'une modification
    // On ajoute emitEvent : false pour ne pas trigger le valueChanges de la methode incrementProcedureVersionWhenFormulaireChangesOnce.
    if (this.procedure) {
      this.procedureForm.controls["version"].setValue(
        +this.procedure.version,
        { emitEvent: false } );
      // On met le boolean à false car on revient en état initial
      this.canUserModify.set(false);

      // le take 1 sert à trigger le valueChange une seule fois (au premier changement apres erreur) pour pouvoir incrementer la version une seule fois
      let procedureFormValueChangesSubscription : Subscription = this.procedureForm.valueChanges.pipe(take(1)).subscribe(() => {
        // On incrémente la version
        this.procedureForm.controls["version"].setValue(
          +this.procedureForm.controls["version"].value + 1
        );
        // On met le boolean qui gere le disable du button enregistrer
        this.canUserModify.set(true);

        // on informe l'utilisateur que la version à bien ètè incrementer
        this.openSnackBar(`Vous êtes maintenant en version ${this.procedureForm.controls["version"].value}`, 'Fermer');
      })
      // On ajoute le subscribe au niveau du tableau des subscribes pour pouvoir unsubscribe dans le ngOnDestroy
      this.subscriptions.push(procedureFormValueChangesSubscription);
    }
  }

  private filterProcedures(value: string, exact: boolean): Observable<any[]> {
    if (value.length < 2) {
      return of([]);
    }
    const filter = exact ? {mnemoniqueExact: value, type: this.types[0].id} : {
      mnemonique: value,
      type: this.types[0].id
    };
    return this.proceduresService.getProcedures(filter).pipe(
      map(response => response.data)
    );
  }

  private filterProceduresByMnemonique(value: string, exact: boolean): Observable<any[]> {
    if (value.length < 2) {
      return of([]);
    }
    const filter = exact ? { mnemoniqueExact: value } : { mnemonique: value };
    return this.proceduresService.getProcedures(filter).pipe(
      map(response => response.data)
    );
  }

  private filterProceduresByTitre(value: string, exact: boolean): Observable<any[]> {
    if (value.length < 2) {
      return of([]);
    }
    const filter = exact ? { titreExact: value } : { titre: value };
    return this.proceduresService.getProcedures(filter).pipe(
      map(response => response.data)
    );
  }

  private filterGroupes(value: string): Observable<Groupe[]> {
    const filterValue = value.toLowerCase();
    return of(this.groupes.filter(groupe => groupe.titre.toLowerCase().includes(filterValue)));
  }

  onGroupSelected(event: any): void {
    const selectedGroup = event.option.value;
    if (!this.selectedGroups.some(group => group.id === selectedGroup.id)) {
      this.selectedGroups.push(selectedGroup);

      selectedGroup.groupeUsers.forEach((groupeUser: any) => {
        if (!this.listeUtilisateursIds.includes(groupeUser.users_id)) {
          this.listeUtilisateursIds.push(groupeUser.users_id);
        }
      });
    }
    this.procedureForm.controls['groupeDiffusion'].setValue('');
    this.updateGroupDiffusionValidation();
  }

  onRemoveGroup(group: Groupe): void {
    this.selectedGroups = this.selectedGroups.filter(g => g.id !== group.id);
    group.groupeUsers.forEach((groupeUser: any) => {
      this.listeUtilisateursIds = this.listeUtilisateursIds.filter(id => id !== groupeUser.users_id);
    });
    this.updateGroupDiffusionValidation();
  }

  updateGroupDiffusionValidation(): void {
    const groupeDiffusionControl = this.procedureForm.get('groupeDiffusion');
    if (this.selectedGroups.length > 0) {
      groupeDiffusionControl?.clearValidators();
    } else {
      groupeDiffusionControl?.setValidators([Validators.required]);
    }
    groupeDiffusionControl?.updateValueAndValidity();
  }

  onValidateEmargement(): void {
    if (this.emargementForm.get('emargementConfirmed')?.value) {
      this.emargementDone = true;

      this.snackBar.open("L'émargement a bien été pris en compte", 'Fermer', { duration: 3000 });

      // informer "modifier-procedure" pour persister l’émargement
      this.emargementValidated.emit();
    }
  }

  async loadCategories(): Promise<void> {
    try {
      const response = await firstValueFrom(this.categoryService.getCategories());
      this.categories = response.data;
    } catch (error) {
      console.error('Error loading categories', error);
      throw error;
    }
  }

  async loadModes(): Promise<void> {
    try {
      const response = await firstValueFrom(this.modeService.getModes());
      this.modes = response.data;
    } catch (error) {
      console.error('Error loading modes', error);
      throw error;
    }
  }

  async loadTypes(): Promise<void> {
    try {
      const response = await firstValueFrom(this.typeService.getTypes());
      this.types = response.data;
    } catch (error) {
      console.error('Error loading types', error);
      throw error;
    }
  }

  async loadEtat(): Promise<void> {
    try {
      const response = await firstValueFrom(this.etatService.getEtats());
      this.etats = response.data;
    } catch (error) {
      console.error('Error loading etats', error);
      throw error;
    }
  }

  async loadPerimetres(): Promise<void> {
    try {
      const response = await firstValueFrom(this.perimetreService.getPerimetres());
      this.perimetres = response.data;
    } catch (error) {
      console.error('Error loading perimetres', error);
      throw error;
    }
  }

  loadGroupes() {
    const params = { limit: 500, actif: true };
    this.subscriptions.push(
      this.groupesService.getGroupes(params).subscribe({
        next: (response) => {
          this.groupes = response.data;
        },
        error: (error) => {
          console.error('Erreur lors du chargement des groupes', error);
        }
      })
    );
  }

  async loadSelectedGroups(): Promise<void> {
    const groupLoadObservables: Observable<Groupe>[] = this.procedure.groupeUtilisateurs.map((groupId: number) =>
      this.groupesService.getGroupeById(groupId).pipe(
        map(response => response.data)
      )
    );

    try {
      const loadedGroups = await firstValueFrom(of(groupLoadObservables).pipe(
        switchMap(observables => observables.length > 0 ? forkJoin(observables) : of([]))
      ));

      this.selectedGroups = loadedGroups;

      this.listeUtilisateursIds = [];
      this.selectedGroups.forEach(group => {
        group.groupeUsers.forEach((groupeUser: any) => {
          if (!this.listeUtilisateursIds.includes(groupeUser.users_id)) {
            this.listeUtilisateursIds.push(groupeUser.users_id);
          }
        });
      });
      console.log('this.listeUtilisateursIds', this.listeUtilisateursIds);
      this.updateGroupInput();

    } catch (error) {
      console.error('Error loading selected groups', error);
    }
  }

  updateGroupInput(): void {
    if (this.selectedGroups && this.selectedGroups.length > 0) {
      const groupe = this.selectedGroups.map(group => group.titre).join(', ');
      this.procedureForm.patchValue({
        groupeDiffusion: groupe
      });
    }
  }

  async loadUser(): Promise<void> {
    try {
      this.connectedUser = await firstValueFrom(this.authService.connectedUser$);
    } catch (error) {
      console.error('Error loading user', error);
      throw error;
    }
  }

  onCancel() {
    this.router.navigate(['liste-procedures']);
  }

  async onSubmit(etatLibelle: string) {
    console.log('onSubmit', etatLibelle);
    const etat = this.etats.find((etat: any) => etat.libelle === etatLibelle)?.id;

    if (this.procedureForm.valid) {

      // on utilise getRawValue() pour avoir l'ensemble des valuers même ceux sui sont disabled dans le formGroup ( exemple : version )
      const formValue = this.procedureForm.getRawValue();
      let mnemoRef = "";
      if (this.procedure) {
        mnemoRef = this.procedure.mnemoniqueRef ? this.procedure.mnemoniqueRef : "";
      } else if (this.procedureReference) {
        mnemoRef = this.procedureReference.id;
      } else {
        mnemoRef = formValue.mnemoniqueRef;
      }

      const procedureBody = new ProcedureBody(
        formValue.isPOE === 'POE',
        mnemoRef,
        formValue.mnemonique,
        formValue.titre,
        formValue.isSecurite,
        formValue.reference,
        +formValue.version,
        formValue.tags,
        this.formatDate(formValue.dateDebutValidite),
        this.formatDate(formValue.dateFinValidite),
        formValue.category,
        formValue.mode,
        formValue.type,
        this.getAnnexes(formValue),
        etat,
        this.selectedGroups.map(group => group.id),
        this.listeUtilisateursIds,
        formValue.perimetre,
        formValue.contexte,
        formValue.commentaire,
        this.connectedUser?.given_name,
        this.connectedUser?.name,
        this.connectedUser?.mail,
        this.logigramme
      );
      try {
        //  creer une procedure ou la mettre a jour
        let procedureResponse;

        if (this.procedure) {
          const archiveProcedureBody = new ProcedureBody(
            this.procedure.isPOE,
            this.procedure.mnemoniqueRerefence, // Attention : vérifiez la cohérence avec vos propriétés
            this.procedure.mnemonique,
            this.procedure.titre,
            this.procedure.isSecurite,
            this.procedure.reference,
            +this.procedure.version, 
            this.procedure.tags,
            this.procedure.dateDebutValidite || '',
            this.procedure.dateFinValidite || '',
            this.procedure.category.id,
            this.procedure.mode.id,
            this.procedure.type.id,
            this.procedure.annexes.map((a: any) => a.id),
            this.etats.find((etat: any) => etat.libelle === this.EtatEnum.ARCHIVE)?.id, 
            this.procedure.groupeUtilisateurs,
            this.procedure.listeUtilisateursIds, 
            this.procedure.perimetre.id,
            this.procedure.contexte,
            this.procedure.commentaire,
            this.procedure.prenomCreateur,
            this.procedure.nomCreateur,
            this.procedure.emailCreateur,
            this.procedure.logigramme
          );
          procedureResponse = await firstValueFrom(this.proceduresService.updateProcedure(this.procedure.id, archiveProcedureBody));
          const createResponse = await firstValueFrom(this.proceduresService.postProcedure(procedureBody));

          if (this.currentEtat === EtatEnum.ARCHIVE) {
            this.openSnackBar('Procédure archivée avec succès!', 'Fermer');
          }
          if (this.currentEtat === EtatEnum.EN_ATTENTE && etatLibelle === EtatEnum.EN_APPLICATION) {
            this.openSnackBar('Procédure mise à jour avec succès!', 'Fermer');
          }
        }
        else {
          const hasFiles = !(!this.files || this.files.length === 0) && (!this.procedureReference?.annexes || this.procedureReference.annexes.length === 0);
          const hasLogigramme = this.logigramme && Object.keys(this.logigramme).length > 0;
          if (!hasFiles && !hasLogigramme) {
            this.openSnackBar('Veuillez ajouter au moins un fichier ou créer un logigramme avant de soumettre.', 'Fermer');
            return;
          }
          procedureResponse = await firstValueFrom(this.proceduresService.postProcedure(procedureBody));
        }

        const procedureId = procedureResponse.data.id;

        if (this.files?.length) {
          // preparer les annexes
          const formData = new FormData();
          this.files.forEach(file => formData.append('files', file));

          // creer les annexes
          const annexesResponse = await firstValueFrom(this.annexeService.postAnnexe(formData));

          // associer les annexes a la procedure
          const currentAnnexes = this.procedure ? this.procedure.annexes.map((el: any) => el.id) : [];
          await firstValueFrom(this.proceduresService.updateProcedure(procedureId, {annexes: [...currentAnnexes, ...annexesResponse]}));
          this.openSnackBar('Procédure créée avec succès!', 'Fermer');
        }

        if (this.emargementData) {
          this.emargementData.showEmargement = true;
          this.emargementDone = false;
          this.emargementValidated.emit();

          await firstValueFrom(this.emargementsUsersService.updateEmargementUser(
            this.emargementUser.id, { emarged: false }
          ));

        }

       await this.router.navigate(['liste-procedures']);

      } catch (error) {
        if((error as HttpErrorResponse).error) {
          let errorWithFunctionalError = (error as HttpErrorResponse).error;
          if(errorWithFunctionalError.message) {
            this.openSnackBar(errorWithFunctionalError.message, "Fermer");
            // On check si c'est une erreur en relation avec version pour le moment, c'est le plus simple pour check, à revoir si besoin.
            if(errorWithFunctionalError.message.includes('version')) {
              // en cas d'erreur liée à la version on reinit la version et on remet le valueChange (inclus dans la méthode) pour gérer les changements.
              this.reInitProcedureVersionWhenFormulaireDidntChangeAfterBffCheck();
            }
          } else {
            this.openSnackBar('Une erreur est survenue lors de la modification', "Fermer");
          }
        }
        throw error;
      }
    }
  }

  private getAnnexes(formValue: any) {
    if (this.procedure) {
      return this.procedure.annexes.map((a: any) => a.id);
    }
    return formValue.annexes && formValue.annexes.length > 0 ? formValue.annexes : [];
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: this.verticalPosition
    });
  }

  private formatDate(date: string): string {
    if (!date) return '';
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
    const day = ('0' + dateObj.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  get tags(): FormArray {
    return this.procedureForm.get('tags') as FormArray;
  }

  addTag(tag: any): void {
    this.tags.push(this.fb.control(tag.value));
    tag.chipInput!.clear();
  }

  removeTag(tag: string): void {
    const index = this.tags.controls.findIndex(control => control.value === tag);
    if (index >= 0) {
      this.tags.removeAt(index);
    }
  }

  handleFilesUploaded($event: any) {
    this.files = $event;
  }

  isProcedureInit() {
    if (!this.procedureForm.get('type')?.value) {
      return true;
    }
    const init = this.types.find((type: any) => type.id === this.procedureForm.get('type')?.value);
    return init.libelle === this._procdureInitialeLibelle;
  }

  onTypeSelect($event: MatSelectChange) {
    const selectedValue = $event.value;
    const typeLibelle = this.types.find((type: any) => type.id === selectedValue)?.libelle;
    if (typeLibelle === TypeProcedureEnum.POE) {
      this.isPOE = true;
      this.isIOE = false;
    }
    if (typeLibelle === TypeProcedureEnum.IOE) {
      this.isIOE = true;
      this.isPOE = false;
    }
    if (typeLibelle === TypeProcedureEnum.PROCEDURE_INITIALE) {
      this.isIOE = false;
      this.isPOE = false;
      // remove validators for mnemoniqueRef, dateDebutValidite, dateFinValidite
      this.procedureForm.get('mnemoniqueRef')?.clearValidators();
      this.procedureForm.get('dateDebutValidite')?.clearValidators();
      this.procedureForm.get('dateFinValidite')?.clearValidators();
    }
    this.procedureForm.updateValueAndValidity();
    this.resetProcedureForm();
  }

  deleteAnnexe(annexe: any) {
    const procedure = this.procedure || this.procedureReference;

    if (procedure?.annexes) {
      procedure.annexes = procedure.annexes.filter((a: any) => a !== annexe);
      this.procedureForm.patchValue({ annexes: procedure.annexes.map((p: any) => p.id) });
    } else {
      console.error("Impossible de supprimer l'annexe : les annexes sont introuvables.");
    }
  }

  async onMnemoniqueBlurRef() {
    this.filterProcedures(this.procedureForm.get('mnemoniqueRef')?.value, true).subscribe((procedures: any) => {
      if (!procedures.length) {
        this.procedureForm.get('mnemoniqueRef')?.setErrors({mnemoniqueNotExists: true});
      }
    });
  }

  async onMnemoniqueBlur() {
    this.filterProceduresByMnemonique(this.procedureForm.get('mnemonique')?.value, true).subscribe((procedures: any) => {
      if (procedures.length && this.procedure?.mnemonique !== procedures[0].mnemonique) {
        this.procedureForm.get('mnemonique')?.setErrors({ mnemoniqueExists: true });
      }
    });
  }

  async onTitreBlur() {
    const titreValue = this.procedureForm.get('titre')?.value?.trim();
    if (!titreValue) return;

    this.filterProceduresByTitre(titreValue, true).subscribe((procedures: any[]) => {
      const titreExists = procedures.some(procedure =>
        procedure.titre.toLowerCase() === titreValue.toLowerCase()
      );

      if (titreExists && (!this.procedure || this.procedure.titre?.toLowerCase() !== titreValue.toLowerCase())) {
        this.procedureForm.get('titre')?.setErrors({ titreExists: true });
      } else {
        this.procedureForm.get('titre')?.setErrors(null);
      }
    });
  }

  mnemoniqueDisabled() {
    const selectedType = this.procedureForm.get('type')?.value;
    if (!selectedType) {
      return false;
    }
    const type = this.types.find((type: any) => type.id === selectedType);
    if (type && type.libelle === "IOE") {
      return true;
    }
    return false;
  }

  openDeleteDialog(id: string): void {
    const dialogRef = this.dialog.open(DeleteProcedureDialogComponent, {
      width: '500px',
      height: '180px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteProcedure(id);
      }
    });
  }

  deleteProcedure(id: string): void {
    this.subscriptions.push(
      this.proceduresService.deleteProcedure(id).subscribe({
        next: () => {
          this.openSnackBar('La procédure a bien été supprimée', 'Fermer');
          this.router.navigate(['liste-procedures']);
        },
        error: (error) => {
          console.error('Erreur lors de la suppression de la procédure', error);
          this.openSnackBar('Erreur : la procédure n\'a pas pu être supprimée', 'Fermer');
        }
      })
    )

  }

  async getProcedureInfos(selected: any) {
    const selectedType = this.procedureForm.get('type')?.value;
    const type = this.types.find((type: any) => type.id === selectedType);

    const selectedProcedure = selected.option.value;
    const proceduresRes = await firstValueFrom(this.filterProcedures(selectedProcedure, true));
    const procedureId = proceduresRes[0].id;
    const res = await firstValueFrom(this.proceduresService.getProcedureById(procedureId));
    const procedure = res.data;
    this.procedureReference = procedure;

    this.procedureForm.patchValue({
      titre: procedure.titre,
      isSecurite: procedure.isSecurite ?? 'non',
      reference: procedure.reference,
      version: procedure.version,
      category: procedure.category.id,
      mode: procedure.mode.id,
      etat: procedure.etat.id,
      dateDebutValidite: this.formatDate(procedure.dateDebutValidite),
      dateFinValidite: this.formatDate(procedure.dateFinValidite),
      annexes: procedure.annexes.map((el: any) => el.id),
      contexte: procedure.contexte,
      commentaire: procedure.commentaire,
      perimetre: procedure.perimetre.id,
      logigramme: procedure.logigramme
    });

    if (type && type.libelle === "IOE") {
      this.procedureForm.patchValue({
        mnemonique: procedure.mnemonique
      });
    }

    let tagsFormArray = this.procedureForm.get('tags') as FormArray;
    tagsFormArray.clear();
    procedure.tags.forEach((tag: string) => {
      tagsFormArray.push(this.fb.control(tag));
    });
  }

  resetProcedureForm() {
    this.procedureForm.patchValue({
      mnemonique: '',
      mnemoniqueRef: '',
      titre: '',
      // isSecurite: '',
      reference: '',
      version: DEFAULT_PROCEDURE_VERSION,
      tags: [],
      dateDebutValidite: '',
      dateFinValidite: '',
      category: '',
      mode: '',
      etat: '',
      perimetre: '',
      annexes: '',
      contexte: '',
      commentaire: '',
      logigramme: null
    });
  }

  validFrom() {
    Object.keys(this.procedureForm.controls).forEach(key => {
      const controlErrors = this.procedureForm.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach(keyError => {
        });
      }
    });
    return this.procedureForm.valid;
  }

  dateFinValiditeFilter = (date: Date | null): boolean => {
    const startDateValue = this.procedureForm.get('dateDebutValidite')?.value;
    const startDate = startDateValue ? new Date(startDateValue) : null;
    return date && startDate ? date >= startDate : true;
  };

  openDocumentViewDialog(annexe: Annexe): void {
    this.dialog.open(DocumentViewDialogComponent, {
      width: '80%',
      height: '80%',
      data: { annexe }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
    // En sortant du composant, on vide le cache
    sessionStorage.clear();
  }

  openReadOnlyLogigrammeDialog() {
    if(this.procedure) {
      this.dialog.open(JointjsReadonlyModalComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '100%',
        width: '100%',
        data: { logigramme: this.logigramme, procedureTitre: this.procedure?.titre }
      });
    }
  }

  openJointjsModal(readOnly: boolean) {
    // Si on a un logigramme stocké dans le sessionStorage on le récupère.
    const storedLogigramme = sessionStorage.getItem(this.procedure?.mnemonique);
    if (storedLogigramme) {
      this.logigramme = JSON.parse(storedLogigramme);
    }
    const dialogRef = this.dialog.open(JointjsModalComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: { logigramme: this.logigramme, procedureTitre: this.procedure?.titre, procedureMnemonique: this.procedure?.mnemonique, readOnly: readOnly, idEditMode: this.idEditMode }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.logigramme = result;
        // On check bien si on est en cas de modification
        if(!readOnly) {
          // On ajoute emitEvent : true pour faire trigger le valueChanges de la methode incrementProcedureVersionWhenFormulaireChangesOnce comme ça, c'est incrementer une seule fois.
          // Petite astuce : on n'incrémente pas la version ici , on laisse le value change en haut s'en occuper comme ça on est sûr qu'il sera incrémenter qu'une seule fois.
          this.procedureForm.controls["version"].setValue(
            +this.procedureForm.controls["version"].value,
            { emitEvent: true }
          );
          // on informe l'utilisateur que la version à bien ètè mise à jour
          this.openSnackBar(`Vous êtes maintenant en version ${this.procedureForm.controls["version"].value}`, 'Fermer');
          if(this.idEditMode ){
            this.openSnackBar('Votre logigramme est enregistré en cache, veuillez cliquer sur enregistrer pour valider la mise à jour'  , 'Fermer');
          } else {
            this.openSnackBar('Votre logigramme est enregistré en cache, veuillez valider la création ou la mise en attente d\'activation' , 'Fermer');
          }          
        }
      }
    });
  }

  protected readonly Object = Object;

  createOrUpdateLogigramme() {
    this.openJointjsModal(false);
  }

  readOnlyLogigramme() {
    this.openJointjsModal(true);
  }

}
